module.exports = __webpack_public_path__ + "img/VERONICA_m.9b2bedbd.png";